// Conexão Hocuspocus por documento Yjs. Reusa por nome (singleton).
// Em produção, URL do WS vem do `import.meta.env.VITE_HOCUSPOCUS_URL`
// ou via fallback `ws(s)://<host>/yjs`.

import { HocuspocusProvider } from '@hocuspocus/provider';
import * as Y from 'yjs';

interface ProviderEntry {
  provider: HocuspocusProvider;
  doc: Y.Doc;
  refs: number;
}

const cache = new Map<string, ProviderEntry>();

function resolveUrl(): string {
  const env = (import.meta as { env?: { VITE_HOCUSPOCUS_URL?: string } }).env;
  if (env?.VITE_HOCUSPOCUS_URL) return env.VITE_HOCUSPOCUS_URL;
  const proto = window.location.protocol === 'https:' ? 'wss:' : 'ws:';
  return `${proto}//${window.location.host}/yjs`;
}

export interface SynapseProvider {
  doc: Y.Doc;
  provider: HocuspocusProvider;
  release: () => void;
}

export function acquireProvider(name: string): SynapseProvider {
  const existing = cache.get(name);
  if (existing) {
    existing.refs++;
    return wrap(name, existing);
  }
  const doc = new Y.Doc();
  const provider = new HocuspocusProvider({
    url: resolveUrl(),
    name,
    document: doc,
    // Token marcador para triggar handshake de auth no provider.
    // Auth real é feita server-side via cookie (synapse_sid).
    token: 'cookie',
  });
  const entry: ProviderEntry = { provider, doc, refs: 1 };
  cache.set(name, entry);
  return wrap(name, entry);
}

function wrap(name: string, entry: ProviderEntry): SynapseProvider {
  return {
    doc: entry.doc,
    provider: entry.provider,
    release: () => {
      entry.refs--;
      if (entry.refs <= 0) {
        entry.provider.destroy();
        cache.delete(name);
      }
    },
  };
}

